module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921094149_T.93ac75e8.jpg";